import React from 'react';
import { Sidebar as RsuiteSidebar, Sidenav, Navbar, Nav } from 'rsuite';
import { useParams, useNavigate } from 'react-router-dom';
import AngleLeftIcon from '@rsuite/icons/legacy/AngleLeft';
import AngleRightIcon from '@rsuite/icons/legacy/AngleRight';
import DashboardIcon from '@rsuite/icons/Dashboard';
import GroupIcon from '@rsuite/icons/legacy/Group';
import NavToggle from './navToggle';

export default function Sidebar({ expand, setExpand }) {
  const { panel } = useParams();
  const navigator = useNavigate();

  return (
    <RsuiteSidebar
      style={{ display: 'flex', flexDirection: 'column', position: 'relative', height: '100vh' }}
      width={expand ? '17rem' : '3.5rem'}
      collapsible
    >
      <Sidenav.Header>
        <div className={`sidenav-brand${expand ? '' : ' collapsed'}`}>
          <span>АЛТИОРА</span>
        </div>
      </Sidenav.Header>
      <Sidenav expanded={expand} defaultOpenKeys={['3']} appearance="subtle">
        <Sidenav.Body>
          <Nav>
            <Nav.Item
              eventKey="Dashboard"
              active={panel === 'main'}
              onClick={() => navigator('/dashboard/main')}
              icon={<DashboardIcon />}
            >
              Брифы
            </Nav.Item>
            <Nav.Item
              eventKey="Reports"
              active={panel === 'reports'}
              onClick={() => navigator('/dashboard/reports')}
              icon={<GroupIcon />}
            >
              Компании
            </Nav.Item>
          </Nav>
        </Sidenav.Body>
      </Sidenav>
      <NavToggle expand={expand} onChange={() => setExpand(!expand)} />
    </RsuiteSidebar>
  );
}